const API = process.env.REACT_APP_API_BASE_URL || 'https://api.foreverstudios.com';
const EMAIL_API = process.env.REACT_APP_API_EMAIL_URL || 'https://api-email-service.foreverstudios.com';

const URLS = {
  signin: `${API}/api/admin/auth/signin`,
  userProfile: `${API}/api/admin/user/profile`,
  users: `${API}/api/admin/user`,
  userById: `${API}/api/admin/user`,
  pmUsers: `${API}/api/admin/user/pm-users`,
  resetPassword: `${API}/api/reset_password`,
  resetPasswordManually: `${API}/api/reset_password_manually`,
  searchUsers: `${API}/api/admin/user/search`,
  userFindForPromoCode: `${API}/api/admin/user/fts?query=`,
  userShippingInfo: `${API}/api/admin/user_shipping_info`,
  userBillingInfo: `${API}/api/admin/user_billing_info`,
  zipCodes: `${API}/api/admin/zip_code`,
  product: `${API}/api/admin/product`,
  rushes: `${API}/api/admin/rush-template`,
  positions: `${API}/api/admin/product/position`,
  wizardBadges: `${API}/api/admin/wizard_badges`,
  wizardSteps: `${API}/api/admin/wizard_badges/product`,
  wizardHelpCenter: `${API}/api/admin/wizard_badges/help_center`,
  wizardHelpCenterCategories: `${API}/api/admin/wizard-help-centers-categories`,
  wizardHelpCentersPosition: `${API}/api/admin/wizard-help-centers-position`,
  productGiftImg: `${API}/api/admin/gift_card_image`,
  permissions: `${API}/api/admin/role`,
  pageHelpCenter: `${API}/api/admin/page-help-centers`,
  pageHelpCenterCategories: `${API}/api/admin/page-help-centers-categories`,
  pageHelpCentersPosition: `${API}/api/admin/page-help-centers-position`,
  fileUpload: `${API}/api/admin/file/upload`,
  wizardOrderSection: `${API}/api/admin/wizard_badges/order_section`,
  wizardBadgesStep: `${API}/api/admin/wizard_badges/steps`,
  frameTemplateCollections: `${API}/api/admin/frame_material`,
  createTemplateFrames: `${API}/api/admin/product/photo_art/all`,
  photoArtDetails: `${API}/api/admin/product/photo_art`,
  sizes: `${API}/api/admin/frame_size`,
  colors: `${API}/api/admin/frame_color`,
  productCustomSizeSettings: `${API}/api/admin/product-custom-size-settings`,
  categoriesArticle: `${API}/api/admin/article_category`,
  frameDisplay: `${API}/api/admin/frame_display`,
  collage: `${API}/api/admin/collage`,
  pageCollections: `${API}/api/product-collections`,
  article: `${API}/api/admin/article`,
  articleBanner: `${API}/api/admin/article_banner`,
  productCollections: `${API}/api/product-collections`,
  frameOptionDisplays: `${API}/api/admin/frame_display`,
  promotionCoupons: `${API}/api/admin/promo-codes`,
  promotionCouponsFts: `${API}/api/admin/promo-codes/search`,
  foreverClubCard: `${API}/api/admin/forever-club-cards`,
  promoCategories: `${API}/api/admin/promo-codes/categories`,
  orderAndProjectStatuses: `${API}/api/admin/status-information`,
  promoInCategory: (id, promoCodeId) => `${API}/api/admin/promo-codes/${promoCodeId}/categories/${id}`,
  promotionTemplates: `${API}/api/promo-section-templates/admin`,
  smsTemplates: `${API}/api/sms-templates`,
  messagesTemplates: `${API}/api/admin/message-template`,
  frequentlyAskedQuestions: `${API}/api/admin/frequently-asked-questions`,
  frequentlyAskedQuestionsTemplate: `${API}/api/admin/frequently-asked-questions-template`,
  promoSections: `${API}/api/promo-section/admin`,
  productPreviewImages: `${API}/api/admin/products-preview-images`,
  getHintImages: `${API}/api/admin/hint_image/product`,
  hintImage: `${API}/api/admin/hint_image`,
  pageContent: `${API}/api/admin/page-content`,
  pageContentBlock: `${API}/api/admin/page-content-block`,
  companies: `${API}/api/admin/company`,
  companyProducts: `${API}/api/admin/company-products`,
  companyColor: `${API}/api/admin/company-theme-color`,
  companyPage: `${API}/api/admin/company-page`,
  apiConfig: `${API}/api/admin/company-api-config`,
  orders: `${API}/api/admin/order`,
  reports: `${API}/api/admin/report/payments`,
  albums: `${API}/api/admin/albums/templates`,
  // emails
  emailTemplates: `${EMAIL_API}/api/pm-email-templates`,
  emailMarketingTemplates: `${EMAIL_API}/api/marketing-email-templates`,
  sendEmail: `${EMAIL_API}/api/send-email/preview`,
  sendEmailPreview: `${EMAIL_API}/api/send-email/email-preview`,
  journeys: `${EMAIL_API}/api/journeys`,
  journeyItemsReplace: ((id) => `${EMAIL_API}/api/journeys/${id}/journey-items/replace`),
  journeyIntervalsReplace: ((id) => `${EMAIL_API}/api/journeys/${id}/journey-intervals/replace`),
  // Error logs
  errorLogs: `${API}/api/admin/error-logs`,
  errorLogsStats: `${API}/api/admin/error-logs/stats`,
  errorLogsResolve: `${API}/api/admin/error-logs/resolve`,
  // Session Analytics
  analyticsDashboard: `${API}/api/admin/analytics`,
  sessions: `${API}/api/admin/sessions`,
  heatmaps: `${API}/api/admin/heatmaps`,
  frontendErrors: `${API}/api/admin/frontend-errors`,
  alerts: `${API}/api/admin/alerts`,
  analyticsApiKeys: `${API}/api/admin/analytics-api-keys`,
  // Photo Gallery
  photoFolder: `${API}/api/admin/photo-folder`,
  photoImage: `${API}/api/admin/photo-image`,
  photoImageUploadAndProcess: `${API}/api/admin/photo-image/upload-and-process`,
  photoImageTags: `${API}/api/admin/photo-image-tags`,
  // Page Builder
  companyPageBlocks: `${API}/api/admin/company-page-blocks`,
  companyPageBlockTemplatesAdmin: `${API}/api/admin/company-page-block-templates`,
  companyPageAnalytics: (companyId) => `${API}/api/admin/company-page/${companyId}/analytics`,
  companyFormSubmissions: (companyId) => `${API}/api/admin/company/${companyId}/form-submissions`,
  companySubscriptions: `${API}/api/admin/company-subscriptions`,
  companySubscriptionPlans: `${API}/api/company-subscription-plans`,
};

export { API };
export default URLS;
